import { Component } from "react";
import Format from "src/utils/Format";
import "src/components/areas/PriceWidget.css";

interface PriceWidgetProps {
	medianPrice: number;
	lowPrice: number;
	highPrice: number;
	currencySymbol: string;
	timeHorizon: string;
	sales?: number | null;
	yearOnYearChange?: number | null;
	priceSpread?: number | null;
}

function formatCompactPrice(value: number): string {
	if (value >= 1000) return "€" + Math.round(value / 1000) + "K";
	return "€" + value;
}

class PriceWidget extends Component<PriceWidgetProps> {
	render() {
		const { medianPrice, lowPrice, highPrice, currencySymbol, timeHorizon, sales, yearOnYearChange, priceSpread } = this.props;
		const hasInsights = yearOnYearChange != null || priceSpread != null;
		return (
			<div className="price-widget" role="region" aria-label={`Price range ${timeHorizon}`}>
				<div className="price-widget-time-horizon">
					<span className="price-widget-time-badge">Last {timeHorizon}</span>
					{sales != null && (
						<span className="price-widget-sales">
							<span className="price-widget-sales-emoji" aria-hidden="true">🏠</span>
							<span className="price-widget-sales-value">{sales}</span>
							<span className="price-widget-sales-label">sales</span>
						</span>
					)}
				</div>
				<div className="price-widget-prices-row">
					<div className="price-widget-item price-widget-low">
						<span className="price-widget-label price-widget-label-small">Low</span>
						<span id="price-widget-low-value" className="price-widget-value price-widget-value-small">
							{Format.getFormattedCurrency(lowPrice, currencySymbol)}
						</span>
					</div>
					<div className="price-widget-item price-widget-median-block">
						<span className="price-widget-label">Median</span>
						<span id="price-widget-median-value" className="price-widget-value price-widget-value-median">
							{Format.getFormattedCurrency(medianPrice, currencySymbol)}
						</span>
					</div>
					<div className="price-widget-item price-widget-high">
						<span className="price-widget-label price-widget-label-small">High</span>
						<span id="price-widget-high-value" className="price-widget-value price-widget-value-small">
							{Format.getFormattedCurrency(highPrice, currencySymbol)}
						</span>
					</div>
				</div>
				{hasInsights && (
					<div className="price-widget-insights-row">
						{yearOnYearChange != null && (
							<div className="price-widget-insight">
								<span className={`price-widget-insight-arrow ${yearOnYearChange >= 0 ? "price-widget-insight-up" : "price-widget-insight-down"}`}>
									{yearOnYearChange >= 0 ? "\u25B2" : "\u25BC"}
								</span>
								<span className={`price-widget-insight-value ${yearOnYearChange >= 0 ? "price-widget-insight-up" : "price-widget-insight-down"}`}>
									{yearOnYearChange >= 0 ? "+" : ""}{Math.round(yearOnYearChange * 10) / 10}%
								</span>
								<span className="price-widget-insight-label">YoY</span>
							</div>
						)}
						{priceSpread != null && (
							<div className="price-widget-insight">
								<span className="price-widget-insight-icon">&#8596;</span>
								<span className="price-widget-insight-value">{formatCompactPrice(priceSpread)}</span>
								<span className="price-widget-insight-label">spread</span>
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

export default PriceWidget;
